<a class="shortcut-menu__button" href="{{ grafanaUrl() }}" target="_blank">
  <svg-icon src="assets/images/icons/out.svg"></svg-icon>
  <span>{{ "ShortcutMenu.Grafana" | translate }} </span>
</a>
